// How often the problem behind an idea happens. Stored as the number, so the order (most often first)
// can be compared and sorted; ideas submitted before it was asked have none.
export const IDEA_FREQUENCIES = {
  DAILY_WEEKLY: 0,
  MONTHLY: 1,
  RARELY: 2,
  ONCE: 3,
} as const;

export type IdeaFrequency = (typeof IDEA_FREQUENCIES)[keyof typeof IDEA_FREQUENCIES];

export const IDEA_FREQUENCY_VALUES = Object.values(IDEA_FREQUENCIES) as IdeaFrequency[];

// The one place the numbers get their wording: the form, idea page, admin panel, edit history and CSV.
export const IDEA_FREQUENCY_LABELS: Record<IdeaFrequency, string> = {
  [IDEA_FREQUENCIES.DAILY_WEEKLY]: 'Daily / Weekly',
  [IDEA_FREQUENCIES.MONTHLY]: 'Monthly',
  [IDEA_FREQUENCIES.RARELY]: 'Rarely (a few times a year)',
  [IDEA_FREQUENCIES.ONCE]: 'Once so far',
};
